import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  & cc-icon {
    color: #5b36f2;
  }

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
  }
  &:hover {
    background-color: #e2dffd;
    outline: none;
    box-shadow: none;
  }

  &:active {
    background-color: #c6c0fc;
    outline: none;
    box-shadow: none;
    & cc-icon {
      color: #5b36f2;
    }
    p {
      color: #5b36f2;
    }
  }

  &:focus-visible {
    background-color: #5b36f2;
    outline: 2px solid white;
    box-shadow: 0 0 0 4px #5b36f2;
    & cc-icon {
      color: #ffffff;
    }
    p {
      color: #ffffff;
    }
  }
`;
